export default "__VITE_ASSET__Dnd8mUld__"